import { SizableText, XStack } from "tamagui";

type DrawerItemProps = {
  icon?: string;
  label: string;
  onPress?: () => void;
  active?: boolean;
};

export function DrawerItem({
  label,
  onPress,
  active = false,
}: DrawerItemProps) {
  return (
    <XStack
      ai="center"
      py="$3"
      px="$2"
      br="$2"
      bg={active ? "$gray8" : "transparent"}
      pressStyle={{ opacity: 0.7 }}
      hoverStyle={{ bg: "$gray8" }}
      onPress={onPress}
    >
      <SizableText
        col="white"
        size="$3"
        fow="600"
        textTransform="uppercase"
        numberOfLines={1}
        ellipsizeMode="tail"
      >
        {label}
      </SizableText>
    </XStack>
  );
}
